var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.246 3C1.313 3 .552 3.754.552 4.69v10.345c0 .936.761 1.69 1.694 1.69h5.858v3.202h-.932a.75.75 0 0 0 0 1.5h6.922a.75.75 0 0 0 0-1.5h-.714v-3.202h2.87v3.207c0 .767.563 1.568 1.464 1.568h4.572c.901 0 1.464-.801 1.464-1.568v-8.364c0-.767-.563-1.568-1.464-1.568h-1.354V4.69c0-.936-.76-1.69-1.694-1.69zm15.468 7c-.9 0-1.464.801-1.464 1.568v3.657H2.246a.19.19 0 0 1-.194-.19V4.69c0-.102.084-.19.194-.19h16.992c.11 0 .194.088.194.19V10zm.036 1.568q.002-.047.014-.068h4.472a.2.2 0 0 1 .014.068v8.364a.2.2 0 0 1-.014.068h-4.472a.2.2 0 0 1-.014-.068zm-8.146 8.36v-3.203h2.276v3.202z",
    clipRule: "evenodd"
  })));
};
export default SvgDevices;